import { http } from '../../config/axios'

export interface RegistrarPagamentoFaturaRequest {
  id: string
  valorPago: number
  dataPagamento: Date
}

export default function putFaturaRegistrarPagamentoService(
  request: RegistrarPagamentoFaturaRequest
): Promise<string> {
  return http
    .put('/api/fatura/registrar-pagamento', request)
    .then((res) => res.data as string)
    .catch((error) => {
      console.error('Erro ao registrar pagamento da fatura', error)
      throw Error(error.response?.data)
    })
}
